// 活动
// 智能测需
const reviewsAI = (r) => require.ensure([], () => r(require('@/pages/activity/reviewsAI')), 'reviewsAI');
//大童介绍页
const dtIndexPage = (r) => require.ensure([], () => r(require('@/pages/activity/dtIndex/index')), 'dtIndexPage');
//数字化证书
const certificate = (r) => require.ensure([], () => r(require('@/pages/activity/certificate/index')), 'certificate');
//H5营销推广页
const brochure = (r) => require.ensure([], () => r(require('@/pages/activity/brochure/index')), 'brochure');
//抖音视频号二次支付页面
const dyvidPay = (r) => require.ensure([], () => r(require('@/pages/activity/douyin/dyvidPay')), 'dyvidPay');
//一月生日活动
const janBirthday = (r) => require.ensure([], () => r(require('@/pages/activity/janBirthday/index')), 'janBirthday');
//3月客户促活
const marchActivation = (r) => require.ensure([], () => r(require('@/pages/activity/marchActivation')), 'marchActivation');
//4月客户促活-节税保
const aprilActivation = (r) => require.ensure([], () => r(require('@/pages/activity/aprilActivation')), 'aprilActivation');
//4月旅行险
const travelActivation = (r) => require.ensure([], () => r(require('@/pages/activity/travelActivation')), 'travelActivation');
//3.5%产品冲刺活动
const interestActivation = (r) => require.ensure([], () => r(require('@/pages/activity/interestActivation')), 'interestActivation');
//3.5%产品冲刺活动
const interestActivation2 = (r) => require.ensure([], () => r(require('@/pages/activity/interestActivation2')), 'interestActivation2');
//双升计划DAC客户养老体验金活动 
const oldPension = (r) => require.ensure([], () => r(require('@/pages/activity/oldPension/index')), 'oldPension');
//红包领取页面
const programme = (r) => require.ensure([], () => r(require('@/pages/activity/oldPension/programme')), 'programme');
//红包领取页面
const redPacket2 = (r) => require.ensure([], () => r(require('@/pages/activity/oldPension/redPacket2')), 'redPacket2');
//保险收益体验金
const experienceGold = (r) => require.ensure([], () => r(require('@/pages/activity/experienceGold/index')), 'experienceGold');
//保险收益体验金落地页
const LandingPage = (r) => require.ensure([], () => r(require('@/pages/activity/experienceGold/LandingPage')), 'LandingPage');
//红包领取页面
const redPacket = (r) => require.ensure([], () => r(require('@/pages/activity/redPacket')), 'redPacket');


// 老王商务1V1定制 0.1元付费
const oneConsult = r =>
  require.ensure([], () => r(require("@/pages/wxPay/oneConsult")), 'oneConsult');
// 老王商务1V1定制 付费成功页
const oneSuccess = r =>
  require.ensure([], () => r(require("@/pages/wxPay/oneSuccess")), 'oneSuccess');

//9月活动一
const september01 = (r) => require.ensure([], () => r(require('@/pages/activity/september/index1')), 'september01');
//9月活动二
const september02 = (r) => require.ensure([], () => r(require('@/pages/activity/september/index2')), 'september02');
//38活动
const hd0308 = (r) => require.ensure([], () => r(require('@/pages/activity/hd0308/index')), 'hd0308');

const yyhdyy = (r) => require.ensure([], () => r(require('@/pages/activity/yyhdyy')), 'yyhdyy');
const yyhdPay = (r) => require.ensure([], () => r(require('@/pages/activity/yyhdPay')), 'yyhdPay');
const yyhdSuc = (r) => require.ensure([], () => r(require('@/pages/activity/yyhdSuc')), 'yyhdSuc');
const yyhdzp = (r) => require.ensure([], () => r(require('@/pages/activity/yyhdzp')), 'yyhdzp');


//客户转介绍 
const juneCustomerReferral = (r) => require.ensure([], () => r(require('@/pages/activity/customerReferral/index')), 'customerReferral');
//团队列表
const teamRanking =  (r) => require.ensure([], () => r(require('@/pages/activity/customerReferral/teamRanking')), 'teamRanking');
//团队详情
const teamRankingDetails =  (r) => require.ensure([], () => r(require('@/pages/activity/customerReferral/teamRankingDetails')), 'teamRankingDetails');
//健康金明细
const healthGold = (r) => require.ensure([], () => r(require('@/pages/activity/customerReferral/healthGold')), 'healthGold');
//客户健康金明细
const customerHealthGold = (r) => require.ensure([], () => r(require('@/pages/activity/customerReferral/customerHealthGold')), 'customerHealthGold');

//活动数据
const activityData = (r) => require.ensure([], () => r(require('@/pages/activity/customerReferral/activityData')), 'activityData');


const activity = [{
    path: '/reviewsAI',
    component: reviewsAI,
    meta: {
      title: '智能测需',
      jumpinfo: true,
      requireAuth: true,
    }
  },
  {
    path: '/dtIndexPage',
    component: dtIndexPage,
    meta: {
      title: '大童保险管家',
      requireAuth: false,
    }
  },
  {
    path: '/certificate',
    component: certificate,
    meta: {
      title: '数字化顾问认证'
    }
  },
  {
    path: '/brochure',
    component: brochure,
    meta: {
      title: '大童保险服务合作案例',
      iswx: true
    }
  },
  {
    path: '/dyvidPay',
    component: dyvidPay,
    meta: {
      title: '大童保险服务',
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
    }
  },
  {
    path: '/janBirthday',
    component: janBirthday,
    meta: {
      title: '生日献礼',
      jumpinfo: true,
      userinfo: true,
      requireAuth: true,
    }
  },
  {
    path: '/experienceGold',
    component: experienceGold,
    meta: {
      title: '大童教育体验金活动',
      requireAuth: true,
    }
  },
  {
    path: '/LandingPage',
    component: LandingPage,
    meta: {
      title: '大童教育体验金活动',
    }
  },
  {
    path: '/redPacket',
    component: redPacket,
    meta: {
      title: '我的收益',
      requireAuth: true,
    }
  },
  {
    path: "/oneConsult",
    component: oneConsult,
    meta: {
      requireAuth: true,
      jumpinfo: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/oneSuccess",
    component: oneSuccess,
    meta: {
      title: "大童保险服务"
    }
  },
  {
    path: "/marchActivation",
    component: marchActivation,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/aprilActivation",
    component: aprilActivation,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/travelActivation",
    component: travelActivation,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/oldPension",
    component: oldPension,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/programme",
    component: programme,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/redPacket2",
    component: redPacket2,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/interestActivation",
    component: interestActivation,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/interestActivation2",
    component: interestActivation2,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/september01",
    component: september01,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: "/september02",
    component: september02,
    meta: {
      requireAuth: true,
      userinfo: true,
      title: "大童保险服务"
    }
  },
  {
    path: '/hd0308',
    component: hd0308,
    meta: {
      requireAuth: false,
      title: '大童·童管家',
    },
  },
  {
    path: '/yyhdyy',
    component: yyhdyy,
    meta: {
      requireAuth: true,
      title: '童管家服务预约',
    },
  },
  {
    path: '/yyhdPay',
    component: yyhdPay,
    meta: {
      requireAuth: true,
      title: '童管家服务预约',
    },
  },
  {
    path: '/yyhdSuc',
    component: yyhdSuc,
    meta: {
      requireAuth: true,
      title: '童管家服务预约',
    },
  },
  {
    path: '/yyhdzp',
    component: yyhdzp,
    meta: {
      requireAuth: true,
      title: '童管家服务预约',
    },
  },
  {
    path: '/juneCustomerReferral',
    component: juneCustomerReferral,
    meta: {
      requireAuth: true,
      title: '夏日健身打卡挑战赛',
    },
  },
  {
    path: '/teamRanking',
    component: teamRanking,
    meta: {
      requireAuth: true,
      title: '团队榜单',
    }
  },
  {
    path: '/teamRankingDetails',
    component: teamRankingDetails,
    meta: {
      requireAuth: true,
      title: '战队详情',
    }
  },
  {
    path: '/healthGold',
    component: healthGold,
    meta: {
      requireAuth: true,
      title: '健康金明细',
    },
  },
  {
    path: '/khHealthGold',
    component: customerHealthGold,
    meta: {
      requireAuth: true,
      title: '健康金明细',
    },
  },
  {
    path: '/activityData',
    component: activityData,
    meta: {
      requireAuth: true,
      title: '活动数据',
    },

  }
];

export default activity;



// WEBPACK FOOTER //
// ./src/router/activity.js